import React, { Component, useCallback } from "react";
import { withRouter } from "react-router-dom";
import { debounce } from "lodash";
import { Card, Alert, Icon, Tooltip, Form, Checkbox, message } from "antd";
import { MdHourglassEmpty } from "react-icons/md";
import "./FinalView.css";
import { render } from "react-dom";
import { connect } from "react-redux";
import { Select, Tag, Col, Row, Spin } from "antd";
import PopUp from "./PopUp";
import PickupDeliveryFactory from "./PickupDeliveryFactory";
// import ExistingFactoryDescForm from '../../form-section/ExistingFactoryDescForm';
import ExistingFactoryDescForm from "./ExistingFactoryDescForm";
import PopUpForFactory from "./PopUpForFactory";
import * as actions from "../../actions";
import { Create_New_Booking } from "../../actions";
import ScheduleTimeline from "../result-section/finalResultCard/ScheduleTimeline";
import CreatableSelect from "react-select/creatable";
import { getPoNumberBySearch, addPurchaseOrder, searchPOs, searchPurchaseOrdersDetailed, getSelectedCustomBroker, getAllCustomBroker } from "../../GraphQL/entities";
import TransparentOverlay from "./TransparentOverlay";
import DutyAndTax from "../booking/DutyAndTax";
import {
  calculateDutyTaxFee,
  getInsuranceChargeForCommodities,
  calculateBrokerageFee,
  PRIME_FREIGHT_BROKERAGE_FEE,
} from "../../util/getBookingInfo";
import CargoInsurance, { resolveCategoryOption } from "../booking/CargoInsurance";
import BookingRfqSections from "../rfq/BookingRfqSections";
import { createRfq, isRfqConfigured, acceptQuote, bookingRefOf } from "../../util/rfqApi";
import { reportActivity } from "../../util/rateGateApi";
import { getSessionUid, getActivitySource } from "../../util/activitySession";
import { sendSaveQuote } from "../../GraphQL/entities";
import { buildSaveQuotePayload, adaptSectionCharges } from "../../util/saveQuotePayload";
import { containersPayload, commoditiesPayload, warehousePayload, freshWarehouse } from "../../util/rfqSections";
// TODO : test for difference
const { Option } = Select;

// Prime Freight's in-house brokerage (Company "Prime Freight Logistics", flagged
// isCustomBroker) carries the $75 nomination fee; a customer's own third-party
// broker is $0. The legacy radio keyed this off the string 'primeFreight', but the
// FInalView dropdown keys brokers by company id with only { id, companyName } in
// hand — so the Prime-Freight broker is recognised by its company name instead.
const PRIME_FREIGHT_BROKER_NAME = "prime freight logistics";

const isPrimeFreightBroker = (broker) =>
  (broker?.companyName || "").trim().toLowerCase() === PRIME_FREIGHT_BROKER_NAME;

// Money formatter for the duty/tax/total summary — thousands separators + fixed
// 2 decimals so the figures read consistently ("$ 1,234.57").
const money = (value) =>
  `$ ${Number(value || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

// Brokerage fee for the chosen broker: the Prime-Freight nomination fee when Prime
// Freight is nominated, otherwise $0 for the customer's own broker.
const brokerageFeeForBroker = (broker) =>
  isPrimeFreightBroker(broker) ? PRIME_FREIGHT_BROKERAGE_FEE : 0;

const createOption = (label, id, styleNumber) => ({
  label,
  value: label.replace(/\W/g, ""),
  id,
  styleNumber,
});

// Custom loading indicator component
const LoadingIndicator = () => (
  <div style={{ display: 'flex', justifyContent: 'center', padding: '10px', minHeight:'100px' }}>
    <Spin style={{
            margin: 'auto'
        }}
        indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />}
    />
  </div>
);

class StartCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      carrier: "Carrier Name",
      rate: "Rate",
      vesselService: "Vessel Service",
      etdOrigin: new Date(),
      pickUpChange: false,
      deliveryChange: false,
      newPickup: false,
      newDelivery: false,
      poNumbers: [],
      currentPoNumber: "",
      ShowPopUp: false,
      ShowPopUpShipperForm: false,
      ShowPopUpDeliveryForm: false,
      form: {},
      selectedPos: [],
      isLoading: false,
      customBroker:[],
      loadingBrokers: false,
      selectedBroker: null,
      brokerageFee:0,
      AgentProfileInfo:null,
      insuredValue:'',
      insuranceFee:0,
      showDutyAndTax: false,
      commodity:{},
      commodityArr:[{}],
      dutyTax: [{}],
      dutyTax_amount_subtotal: {
        duties: 0,
        taxes: 0,
    }, // State to store dutyTax_amount_subtotal
      // Bumped on each PO import so the CargoInsurance child (which holds its own
      // computed-premium state) remounts and drops its stale internal estimate (#2).
      importEpoch: 0,
      termsAccepted: false,
      // c9 (#75): on-booking RFQ selection for additional services — fired as an
      // RFQ associated to the booking on Create Booking (see maybeCreateBookingRfq).
      rfqInsuranceMode: 'estimate', // 'estimate' | 'rfq'  (#51 either/or)
      rfqCustoms: false, // additive "also RFQ" on top of the duty estimate (#29/#51)
      rfqWarehouse: false, // toggle: request warehouse services via RFQ
      // The warehouse RFQ's service detail (type / units / days / start / notes),
      // collected by the same editor the /rfq/new creator uses → warehouseServices[].
      rfqWarehouseDetail: freshWarehouse(),
      savingQuote: false, // "Save quote" button in-flight
    };

    this.fetchOptions = debounce(this.fetchOptions.bind(this), 300);
  }
  handleDutyTaxChange = (index, key, value) => {
    const { dutyTax } = this.state;
    dutyTax[index][key] = value; // Update the value of the specified key in the reference object
    this.setState({ dutyTax });
  };

  handleAddDutyTax = () => {
      const { dutyTax } = this.state;
      this.setState({
          dutyTax: [...dutyTax, {
              amount: '',
              description: '',
              quantity: '',
              hs_code: '',
          }],
      });
  };

  handleDeleteDutyTax = index => {
      const { dutyTax } = this.state;
      let dutyTaxFiltered = dutyTax.filter((_, idx) => idx !== index);
      // console.log("dutyTax: ",dutyTaxFiltered)
      this.setState({
          dutyTax: dutyTaxFiltered,
      });
      this.props.form.setFieldsValue({ dutyTax: dutyTaxFiltered });
  };

  handleAddCommodity = () => {
    const { commodityArr } = this.state;
    this.setState({
        commodityArr: [...commodityArr, {
            category: '',
            description: '',
            commodityValue: '',
        }],
    });
  };

  handleDeleteCommodity = index => {
      const { commodityArr } = this.state;
      let commodityFiltered = commodityArr.filter((_, idx) => idx !== index);
      // Resync the antd form after filtering, fully (mirrors handleDeleteDutyTax). In
      // antd v3 the field store is keyed by index path and getFieldDecorator's
      // initialValue is ignored after first registration, so deleting a NON-last row
      // leaves the surviving rows showing the deleted row's values. The DELETE path must
      // also repack the commodity CATEGORY — otherwise the shifted rows keep the deleted
      // row's category {value,label} and Calculate Insurance prices the wrong category
      // (#2). (The PO-import path stays on syncImportedRowsToForm, which leaves category
      // untouched so a manually picked category survives the import.)
      this.setState({
          commodityArr: commodityFiltered,
      }, this.syncCommodityRowsToFormWithCategory);
  };

  // Delete-only resync: repack the category form field from state alongside the text
  // fields, using the {value,label} object shape the react-select expects (matching
  // CargoInsurance's getFieldDecorator initialValue). Keeps createCommodityObject's
  // commodity.category.value pointing at the surviving row's real category (#2).
  syncCommodityRowsToFormWithCategory = () => {
    const { form } = this.props;
    if (!form || !form.setFieldsValue) return;
    const commodityArr = (this.state.commodityArr || []).map((c) => ({
      description: c.description || '',
      commodityValue: c.commodityValue || '',
      category: resolveCategoryOption(c.category, this.props.commodityList),
    }));
    form.setFieldsValue({ commodityArr });
  };


  handleCommodityChange = (index, key, value) => {
      const { commodityArr } = this.state;
      commodityArr[index][key] = value; // Update the value of the specified key in the reference object
      this.setState({ commodityArr });
  };

  // When a Purchase Order is selected, pull its commodity (itemDescription +
  // valueOfGoodsUsd) into BOTH the cargo-insurance commodities and the customs
  // duty/tax lines (#179, booking half). The customs HS code is left blank — the
  // user clicks Calculate (DutyAndTax looks it up from the description); the
  // insurance category is picked manually (AI auto-match is a future feature).
  importPoCommodities = async (addedOptions) => {
    for (const opt of addedOptions) {
      try {
        const rows = await searchPurchaseOrdersDetailed(this.props.jwt_token, opt.label);
        const po = (rows || []).find((r) => String(r.id) === String(opt.id)) || (rows || [])[0];
        if (!po) continue;
        const desc = (po.itemDescription || '').trim();
        const value = po.valueOfGoodsUsd != null ? Number(po.valueOfGoodsUsd) : '';
        if (!desc && !(Number(value) > 0)) continue;
        this.setState((s) => {
          const hasCommodity = (c) => c.description || c.commodityValue || c.category;
          const commodityArr = (s.commodityArr || []).filter(hasCommodity);
          commodityArr.push({ category: '', description: desc, commodityValue: value });
          const hasDuty = (d) => d.description || d.hs_code || d.quantity || d.amount;
          const dutyTax = (s.dutyTax || []).filter(hasDuty);
          dutyTax.push({ amount: value, description: desc, quantity: '', hs_code: '' });
          // A PO import changes the commodity set, so any prior duty/tax + insurance
          // estimate (and the Total Price derived from them) is now stale. Reset the
          // DISPLAYED subtotals and clear insuranceArr so the user must re-Calculate;
          // bump importEpoch to remount CargoInsurance and drop its internal premium
          // state too — the on-screen Duties/Taxes/premiums/Total Price never show
          // pre-import numbers (#2, mirrors the creator-side fix).
          return {
            commodityArr,
            dutyTax,
            dutyTax_amount_subtotal: { duties: 0, taxes: 0 },
            insuranceArr: [],
            importEpoch: (s.importEpoch || 0) + 1,
          };
        }, this.syncImportedRowsToForm);
      } catch (err) {
        console.error('PO commodity import failed', err);
      }
    }
  };

  // Push the imported commodity/duty rows into the shared antd form (#4/#5). antd v3
  // applies getFieldDecorator initialValue ONLY on first registration, and keys the
  // field store by name path (dutyTax[i].x), not React identity — so a fresh
  // initialValue on re-render is ignored and a filtered/repacked array leaves stale
  // values at shifted/orphaned indices. setFieldsValue overwrites the index-keyed
  // fields to match the current arrays, so the inputs (and the form.getFieldsValue the
  // Calculate handlers read) reflect what was imported. Only the text fields the
  // import actually fills are synced — the commodity CATEGORY antd field holds a
  // {value,label} object the react-select needs, so it is left untouched (a manually
  // picked category survives the import). Guarded: the form may not be mounted yet.
  syncImportedRowsToForm = () => {
    const { form } = this.props;
    if (!form || !form.setFieldsValue) return;
    const dutyTax = (this.state.dutyTax || []).map((d) => ({
      description: d.description || '',
      hs_code: d.hs_code || '',
      quantity: d.quantity || '',
      amount: d.amount || '',
    }));
    const commodityArr = (this.state.commodityArr || []).map((c) => ({
      description: c.description || '',
      commodityValue: c.commodityValue || '',
    }));
    form.setFieldsValue({ dutyTax, commodityArr });
  };

  handleInsuranceAmountChange = (insurance) => {
    this.setState({ insuranceArr: insurance });
  };

  sanitizeAmount = (value) => {
      if (typeof value === 'number' && !isNaN(value)) return value;
      if (!value) return 0;
      const cleaned = parseFloat(String(value).replace(/[^0-9.-]+/g, ''));
      return isNaN(cleaned) ? 0 : cleaned;
  };

  // Sum commodity premiums with a NaN guard — a 'quote requested' commodity has no
  // premium_amount, so an unguarded Number(undefined) poisons the whole sum to NaN
  // (shown as "$ NaN" + persisted as NaN). One helper for the subtotal display and
  // the booking insuranceFee, matching the guard calculateTotalPrice already uses (#19).
  // bookedOnly → only premiums that actually become a booking charge (a created
  // policy), mirroring getInsuranceChargeForCommodities so the agreed Total Price
  // includes insurance only when the booking record will carry it too (#20).
  sumPremiums = (insuranceArr, bookedOnly = false) =>
      (insuranceArr || []).reduce((sum, item) => {
          if (bookedOnly && !(item?.quote?.result_code === 'quote_created' && item?.policy_id != null)) {
              return sum;
          }
          const premium = Number(item?.quote?.premium_amount);
          return sum + (isNaN(premium) ? 0 : premium);
      }, 0);

  // Cargo insurance is either/or (#51, #11): the instant premium OR competing broker
  // quotes via RFQ — never both. When the customer picked 'rfq', the instant-premium
  // estimate card is hidden and its premium is NOT persisted onto the booking (no INS
  // charge line, zero insuranceFee, excluded from the displayed total) — only the
  // INSURANCE RFQ is spawned (maybeCreateBookingRfq).
  get usesInstantInsurance() {
      return this.state.rfqInsuranceMode !== 'rfq';
  }

  calculateTotalPrice = () => {
      let total = 0;
      let insuranceFee = 0;

      const rawBookNowPrice =
        this.props?.final_search_form?.selected_card_detail?.bookNowPrice ||
        this.props?.final_search_form?.selected_card_json?.bookNowPrice;
      const shippingCost = this.sanitizeAmount(rawBookNowPrice);
      const brokerageFee = this.sanitizeAmount(this.state.brokerageFee);

      const { duties, taxes } = this.state.dutyTax_amount_subtotal;
      const duty = this.sanitizeAmount(duties);
      const tax = this.sanitizeAmount(taxes);

      // Only premiums for commodities with a created policy count toward the agreed
      // Total Price — the booking's INS charge line is gated the same way
      // (getInsuranceChargeForCommodities), so the total and the booked charges agree (#20).
      // When insurance is sent to RFQ (#11), the instant premium is not part of this
      // booking's total — the broker quotes price it instead.
      insuranceFee = this.usesInstantInsurance ? this.sumPremiums(this.state?.insuranceArr, true) : 0;
      // console.log("insurance fee: ",insuranceFee)
      total = shippingCost + insuranceFee + brokerageFee + duty + tax;
      const formattedTotal = Number(total.toFixed(2));
    
      return formattedTotal;
  }

  // Event handler to update dutyTax_amount_subtotal state
  handleDutyTaxAmountSubtotalChange = (amountSubtotal) => {
      this.setState({ dutyTax_amount_subtotal: {duties: amountSubtotal?.Duty, taxes: amountSubtotal?.VAT} });
  };

  handleTermsAcceptance = (event) => {
    const isChecked = event.target.checked;
    this.setState({ termsAccepted: isChecked });
  };

  fetchBrokers = async () =>{
      try {
          this.setState({ loadingBrokers: true });
          const result = await getSelectedCustomBroker(this.props.jwt_token,this.props.user.id)
          if(result && result?.[0] && result[0]){
              const preSelectedBroker = result[1]
              const selectedCustomBroker = preSelectedBroker && preSelectedBroker?.[0]?.customBroker
              // console.log("selectedBroker: ",preSelectedBroker,selectedCustomBroker)
              // Only pre-select when the customer actually has a linked customBroker —
              // result[0] truthy doesn't guarantee one, so guard before reading .id
              // (otherwise "Cannot read properties of undefined (reading 'id')").
              if (selectedCustomBroker) {
                this.setState({
                    selectedBroker: {
                      id: selectedCustomBroker.id,
                      companyName: selectedCustomBroker.companyName,
                    },
                    // Keep the fee in step with a pre-selected default broker too —
                    // Prime Freight Logistics can be a customer's saved broker even
                    // though it isn't a dropdown option (#1).
                    brokerageFee: brokerageFeeForBroker(selectedCustomBroker),
                  });
              }
          }
          const response = await getAllCustomBroker(this.props.jwt_token)
          const brokerData = response && response[1]
          this.setState({ customBroker:brokerData, loadingBrokers: false });
        } catch (error) {
          console.error('Error fetching brokers:', error);
          this.setState({ loadingBrokers: false });
        }
  }

  fetchAgents = async () => {
    const { user, verification } = this.props.initAuth;
    const isUserPresent = !!(user && verification);
    try {
        const response = await this.props.getAllAgentProfiles(isUserPresent);
        const agentProfiles = response && response[1]
        const countryId = this.props.queryParams?.from?.countryId;
        
        if(agentProfiles && countryId && agentProfiles.length > 0){
           
            // #21: tolerate both field spellings (BB action output shape varies) + optional-chain,
            // so this and BookViaAgent can't drift onto opposite names (one side silently unmatched).
            const agentInfo = agentProfiles.find(profile => (profile.country_entity?.id ?? profile.countryEntity?.id) === countryId);
            const agentProfile = agentInfo || null
            
            this.setState({AgentProfileInfo: agentProfile});
        }
    }
    catch (error) {
        console.error('Error fetching agents:', error);
    }
  };

  componentDidMount() {
    this.setState({ isLoading: true });
    this.fetchBrokers();
    this.fetchAgents();
    // Simulate API call to fetch default options
    getPoNumberBySearch(this.props.jwt_token)
      .then((allPoNumbers) => {
        //this.setState({ poNumbers: allPoNumbers });
        const formattedOptions = allPoNumbers?.map((option) =>
          createOption(option.orderNumbers, option.id, option.styleNumber)
        );
        this.setState({ poNumbers: formattedOptions, isLoading: false });
      })
      .catch((error) => {
        console.error("Error fetching default options:", error);
        this.setState({ isLoading: false });
      });
  }
  onFactoryDataChange = () => {
    this.setState({ newPickup: false });
    this.setState({ pickUpChange: true });
    this.setState({ ShowPopUp: false });
  };

  onFactoryDeliveryChange = () => {
    this.setState({ deliveryChange: true });
    this.setState({ newDelivery: false });
  };

  ChaneNewPickFactoryToTrue = () => {
    this.setState({ newPickup: true });
    this.setState({ pickUpChange: false });
  };

  ChaneNewDeliveryFactoryToTrue = () => {
    this.setState({ newDelivery: true });
    this.setState({ deliveryChange: false });
  };

  handleSaveDetails = () => {
    this.setState({ newPickup: false });
    this.setState({ ShowPopUp: false });
    this.setState({ ShowPopUpShipperForm: false });
    this.setState({ ShowPopUpDeliveryForm: false });
    this.setState({ newDelivery: false });
  };

  handleCustomBrokerChnage = (value) =>{
    const selectedBroker = this.state.customBroker.find(broker => broker.companyName === value);
    if (selectedBroker) {
    this.setState({
        selectedBroker: {
        id: selectedBroker.id,
        companyName: selectedBroker.companyName,
        },
        // Derive the brokerage fee FROM the chosen broker so the displayed Total
        // Price and the persisted BROK charge both reflect the selection (#1).
        brokerageFee: brokerageFeeForBroker(selectedBroker),
      });
    }
  }

  validateShipperInfo = () => {
    const { isExistingPickupFactorySelected } = this.props;
    if(Object.keys(isExistingPickupFactorySelected).length >0 ){
        this.setState({ ShowPopUp: false });
        return true;
    }else{
        this.setState({ ShowPopUp: true });
        return false;
    }
};

  // Adapt the booking's duty/tax rows ({ amount, description, quantity, hs_code })
  // to the shared commoditiesPayload customs.lines shape ({ description, hsCode,
  // qty, declaredValue }) so a booking-spawned RFQ posts the SAME commodities[]
  // shape the /rfq/new path does (#2 parity/DRY).
  bookingCustomsLines = () =>
    (this.state.dutyTax || []).map((d) => ({
      description: d.description,
      hsCode: d.hs_code,
      qty: d.quantity,
      declaredValue: d.amount,
    }));

  // The single top-level cargo description used when CUSTOMS isn't requested
  // (commoditiesPayload's fallback) — the first non-empty commodityArr description.
  bookingCommodity = () => {
    const row = (this.state.commodityArr || []).find((c) => c && c.description && c.description.trim());
    return row ? row.description.trim() : '';
  };

  // Σ insured-commodity values on the booking's insuranceArr (commodity_value) —
  // the persisted insuranceDeclaredValue, mirroring the insuredValue reduce the
  // booking already uses (lines ~613) and the /rfq/new declared-value sum (#2).
  bookingInsuranceDeclaredValue = () =>
    (this.state.insuranceArr || []).reduce((sum, item) => {
      const value = Number(item && item.commodity_value);
      return sum + (Number.isFinite(value) ? value : 0);
    }, 0);

  // c9 (#75): if the customer requested competitive quotes for additional services
  // (insurance via RFQ / customs broker RFQ / warehouse), create the RFQ now —
  // associated to the booking just created (#77 forward link: createRfq carries
  // bookingId; C stores it via the passthrough schema). Returns {id,status,sections}
  // (or {error,sections}) for the confirmation, or null when nothing is RFQ'd.
  maybeCreateBookingRfq = async (bookingId) => {
    const sections = [];
    if (this.state.rfqInsuranceMode === 'rfq') sections.push('INSURANCE');
    if (this.state.rfqCustoms) sections.push('CUSTOMS');
    if (this.state.rfqWarehouse) sections.push('WAREHOUSE');
    if (!sections.length || !isRfqConfigured()) return null;

    const fsf = this.props.final_search_form || {};
    const qp = this.props.queryParams || {};
    const oc = qp.from || {};
    const dc = qp.to || {};
    const lane = {};
    // Keep the SCAC port CODE in originPort/destPort (don't stuff a numeric BB id
    // into the code field) and carry the BB port IDs separately so C resolves the
    // lane on ids end-to-end, like the /rfq/new path (#24).
    if (oc.portCode || oc.id) lane.originPort = oc.portCode || oc.id;
    if (dc.portCode || dc.id) lane.destPort = dc.portCode || dc.id;
    if (oc.id != null) lane.originPortRef = oc.id;
    if (dc.id != null) lane.destPortRef = dc.id;
    // Carry the booking's load so the spawned RFQ reaches the workbench with a real
    // Load column instead of "—" (#24): FCL → containerType + containers[]; LCL/Air
    // → containerType + chargeable measure.
    if (fsf.type === 'api-fcl') {
      lane.containerType = 'FCL';
      const containers = containersPayload(fsf.container || {});
      if (containers.length) {
        lane.containers = containers;
        lane.containerSize = containers[0].size;
      }
    } else if (fsf.type === 'api-lcl') {
      lane.containerType = 'LCL';
      const cw = Number(fsf.chargeableWeight);
      if (Number.isFinite(cw) && cw > 0) {
        lane.weight = cw;
        lane.weightUnit = 'KG';
      }
    }

    const payload = {
      mode: fsf.type === 'api-air' ? 'AIR' : 'OCEAN',
      source: 'customer',
      requestedSections: sections,
      sectionMode: sections.reduce((m, s) => ({ ...m, [s]: 'VENDOR_RFQ' }), {}),
      submit: true, // customer + submit -> PENDING_REVIEW (#49)
      bookingId,
    };
    if (Object.keys(lane).length) payload.lane = lane;

    // Attach the declaration the booking page already holds so the spawned RFQ
    // reaches the workbench with something to quote against — matching the /rfq/new
    // (buildRfqPayload) shapes, gated per requested section so unrequested sections
    // send nothing (#2).
    const customsRequested = sections.includes('CUSTOMS');
    const commodities = commoditiesPayload({
      commodity: this.bookingCommodity(),
      customs: { lines: this.bookingCustomsLines() },
      customsRequested,
    });
    if (commodities.length) payload.commodities = commodities;

    // Customs broker — same { choice, name? } shape buildRfqPayload emits, derived
    // from the selected broker (Prime Freight nominates, else the customer's own).
    if (customsRequested && this.state.selectedBroker) {
      const broker = this.state.selectedBroker;
      if (isPrimeFreightBroker(broker)) {
        payload.customsBroker = { choice: 'primeFreight' };
      } else {
        payload.customsBroker = { choice: 'custom' };
        if (broker.companyName) payload.customsBroker.name = broker.companyName;
      }
    }

    // Insurance declared value — only when INSURANCE is RFQ'd.
    if (sections.includes('INSURANCE')) {
      const declared = this.bookingInsuranceDeclaredValue();
      if (declared > 0) payload.insuranceDeclaredValue = declared;
      payload.insuranceCurrency = 'USD';
    }

    // Warehouse services — when WAREHOUSE is RFQ'd, serialize the requested services
    // (type / units / days / start / notes) into the same warehouseServices[] shape
    // buildRfqPayload emits, so a booking-spawned warehouse RFQ reaches the workbench
    // with full detail to quote against instead of a bare "WAREHOUSE" flag.
    if (sections.includes('WAREHOUSE')) {
      const warehouseServices = warehousePayload(this.state.rfqWarehouseDetail);
      if (warehouseServices.length) payload.warehouseServices = warehouseServices;
    }
    try {
      const res = await createRfq(payload);
      // activity-crm PR-2: log the RFQ conversion to the BB event stream (D8).
      // Fire-and-forget — telemetry must never affect the RFQ result.
      reportActivity({ eventType: 'RFQ_CREATED', sessionUid: getSessionUid(), rfqRef: res.rfqId, source: getActivitySource() });
      return { id: res.rfqId, status: res.status, sections };
    } catch (e) {
      return { error: true, sections };
    }
  };

  // Build the normalized saveQuote INPUT from everything on the booking-confirmation
  // screen — including what the rate cards don't show: insurance (instant premium),
  // customs (duty/tax + brokerage) and the requested warehouse services. Freight/drayage
  // come from the same card the booking prices from. Pure (no side effects) so BOTH the
  // "Save quote" button AND the create-booking flow (which needs a quoteId first) reuse it.
  buildSaveQuoteInput = () => {
    const fsf = this.props.final_search_form || {};
    const qp = this.props.queryParams || {};
    const cj = fsf.selected_card_json || {};
    const cont = fsf.container || {};
    const containerType = fsf.type === "api-fcl" ? "FCL" : "LCL";
    const mode = fsf.type === "api-air" ? "AIR" : "OCEAN";
    const fclSizes = containerType === "FCL"
      ? [
          { size: "20", qty: cont._20stCounter, price: Number(cj["20st"]), weight: cj._20stWeight },
          { size: "40", qty: cont._40stCounter, price: Number(cj["40st"]), weight: cj._40stWeight },
          { size: "40HQ", qty: cont._40hqCounter, price: Number(cj["40hq"]), weight: cj._40hqWeight },
          { size: "45", qty: cont._45hqCounter, price: Number(cj["45hq"]), weight: cj._45hqWeight },
        ]
      : [];
    // Insurance — created instant-premium policies (only when the booking uses them, #51).
    const insurance = this.usesInstantInsurance
      ? (this.state.insuranceArr || [])
          .filter((i) => Number(i.commodity_value) > 0)
          .map((i) => ({
            category: i.category,
            description: i.commodity_description,
            value: i.commodity_value,
            premium: i.quote?.premium_amount,
            policyReference: i.policy_id,
          }))
      : [];
    // Customs — API-returned duty/tax totals + brokerage fee → CUSTOMS charges.
    // The SimplyDuty API returns the final totals directly; do NOT derive from
    // product quantity × unit price (that's the product value, not the duty amount).
    const DUTY_TAX_CHARGE_TYPE_ID = 171;
    const BROKERAGE_CHARGE_TYPE_ID = 81;
    const { duties, taxes } = this.state.dutyTax_amount_subtotal;
    const dutyTotal = this.sanitizeAmount(duties);
    const taxTotal = this.sanitizeAmount(taxes);
    const dutyTaxTotal = dutyTotal + taxTotal;
    const customs = [];
    if (dutyTaxTotal > 0) {
      customs.push({ chargeTypeId: DUTY_TAX_CHARGE_TYPE_ID, description: "Duty & Tax", basis: "EA", amount: dutyTaxTotal, quantity: 1 });
    }
    if (Number(this.state.brokerageFee) > 0) {
      customs.push({ chargeTypeId: BROKERAGE_CHARGE_TYPE_ID, description: "Customs Brokerage", basis: "EA", amount: this.state.brokerageFee, quantity: 1 });
    }
    // Warehouse — the requested services (unpriced RFQ requests, recorded for reference).
    const warehouse = this.state.rfqWarehouse
      ? (this.state.rfqWarehouseDetail?.services || [])
          .filter((s) => s.serviceType)
          .map((s) => ({
            chargeTypeId: cj.charge_type_id,
            description: [s.serviceType, s.units && `${s.units} units`, s.days && `${s.days} days`].filter(Boolean).join(" · "),
            basis: "EA", amount: 0, quantity: 1,
          }))
      : [];
    // Card legs (drayage + port fees) the customer configured, round-tripped via
    // final_search_form.selected_card_detail. Same shared mapper + per-leg TYPE rule as the
    // rate-card save; gate each on its checkbox so an unticked leg isn't saved.
    const scd = fsf.selected_card_detail || {};
    const ct = cj.charge_type_id;
    const legSections = {
      ORIGIN: scd.origin_isChecked ? adaptSectionCharges(scd.port_fees_from_charges, ct) : [],
      DESTINATION: scd.discharge_isChecked ? adaptSectionCharges(scd.port_fees_to_charges, ct) : [],
      PICKUP: scd.pickup_isChecked ? adaptSectionCharges(scd.pickup_charges, ct) : [],
      DELIVERY: scd.delivery_isChecked ? adaptSectionCharges(scd.delivery_charges, ct) : [],
    };

    return {
      source: "BOOKING",
      mode,
      containerType,
      currency: "USD",
      // user IS USER_DETAILS (mapStateToProps) — its .id is the customer/company entity id
      // (webuser.entity is null for these logins), so read .id first.
      customerId: this.props.user?.id ?? this.props.user?.webuser?.entity?.id ?? this.props.user?.entity?.id,
      freightChargeTypeId: cj.charge_type_id,
      carrierId: cj.carrier?.id,
      originPortId: qp.from?.id,
      destPortId: qp.to?.id,
      dischargePortId: cj.port_of_discharge?.id,
      vesselServiceId: cj.vessel_Service?.id,
      vendorContractId: cj.vendor_contract?.id,
      validityFrom: cj.valid_date_from,
      validityTo: cj.valid_date_to,
      etdOrigin: cj.etd_origin,
      isOverweight: cj.isOverweight,
      fclSizes,
      chargeableWeight: fsf.chargeableWeight,
      freightRate: Number(fsf.freightRate),
      // LCL/Air metric volume for the Quote header (FCL is container-based → undefined).
      cbm: fsf.total_shipment?.totalVolume,
      // Transit metadata so the saved quote matches an RFQ-assembly quote (consistency).
      transitTime: cj.transitTime ?? cj.schedulesTransitTime,
      totalTransitDays: cj.transitTime ?? cj.schedulesTransitTime,
      estimates: { CUSTOMS: true, WAREHOUSE: true },
      legModes: fsf.legModes || { PICKUP: 'INSTANT_RATE', DELIVERY: 'INSTANT_RATE' },
      sections: { ...legSections, CUSTOMS: customs, WAREHOUSE: warehouse },
      insurance,
    };
  };

  // "Save quote" button on the booking confirmation → build the input, then persist it
  // as a Quote via the coded saveQuote op (replaces the legacy low-code 4c86ee89).
  handleSaveQuote = async () => {
    this.setState({ savingQuote: true });
    try {
      const res = await sendSaveQuote(this.props.jwt_token, buildSaveQuotePayload(this.buildSaveQuoteInput()));
      if (res?.ok) message.success(`Quote saved (#${res.quoteId})`);
      else { console.error("saveQuote error:", res?.error); message.error("Couldn't save the quote — contact Prime Freight"); }
    } catch (e) {
      console.error("saveQuote error:", e);
      message.error("Couldn't save the quote — contact Prime Freight");
    } finally {
      this.setState({ savingQuote: false });
    }
  };

  handleCreateBooking = async () => {
    // The Create Booking button is disabled until terms are accepted (see render), so
    // this handler can't fire with termsAccepted false — the disabled button is the
    // single gating mechanism; the unreachable showTermsError path was dropped (#9).
    const {
      isExistingPickupFactorySelected,
      isExistingDeliveryFactorySelected,
    } = this.props;

    // Validate shipper information
    if (!this.validateShipperInfo()
    ) {
        // Stop the booking creation process if validation fails
        return;
    }
    // RFQ-quote handoff source (Portal "Accept & create booking"). When present, the
    // booking is linked back to this quote in the orchestrator on success (#188).
    const rfqOffer = this.props?.final_search_form?.selected_card_json?.rfqOffer;
    // AIR booking was never built in FInalView / the booking action (no api-air
    // branch below, no air container type) — submitting one corrupts data. For an RFQ
    // air quote, still create the REAL Booking via the orchestrator (linked to the
    // quote, in the RFQ data zone) and show the confirmation; a non-RFQ air rate gets
    // a clear "contact us" message instead of a broken booking.
    if (this.props.final_search_form.type === "api-air") {
      if (rfqOffer && rfqOffer.quoteId != null) {
        // Overlay while acceptQuote is in flight: the accepted-pending branch below keeps
        // the user on FInalView, so without it the Create Booking button stays clickable
        // during the network call → duplicate accepts (Copilot review). Cleared in finally.
        this.props.setTransparentOverlay(true);
        try {
          const linked = await acceptQuote(rfqOffer.quoteId);
          // #P2-2: gate success on the authoritative ref only (bookingRefOf → primeFreightRef,
          // never the fabricated `BKG-…` bookingId). No real Booking is created here yet
          // (#197), so this resolves to null → show the accepted-pending message.
          const bookingRef = bookingRefOf(linked);
          if (bookingRef) {
            this.props.final_booking_button({ bookingSuccessful: true, bookingId: bookingRef });
          } else {
            this.props.updateErrorAndLoading(
              "Your acceptance was received — our team will confirm your air booking shortly.",
              undefined
            );
          }
        } catch (e) {
          // acceptQuote marks the quote/RFQ accepted (it does not create a Booking),
          // so a failure here is an acceptance failure, not a booking-creation one.
          this.props.updateErrorAndLoading("Could not accept the air quote. Please contact Prime Freight.", undefined);
        } finally {
          this.props.setTransparentOverlay(false);
        }
      } else {
        this.props.updateErrorAndLoading("Air bookings aren't available through this screen yet — please contact our team to finalize your air booking.", undefined);
      }
      return;
    }
    const selectedPoNumbers = [];
    let styleNumbers = "";

    if (
      this.state.selectedPos &&
      Array.isArray(this.state.selectedPos) &&
      this.state.selectedPos.length > 0
    ) {
      this.state.selectedPos.map((item) => selectedPoNumbers.push(item.id));
      // Join style numbers if they are not null or empty
      styleNumbers = this.state.selectedPos
        .filter(
          (item) => item && item.styleNumber && item.styleNumber.trim() !== ""
        )
        .map((item) => item.styleNumber)
        .join(", ");
    }
    if (Object.keys(isExistingPickupFactorySelected).length > 0) {
      const delivery_selected_index =
        this.props.final_search_form.selected_card_detail
          .delivery_selected_option_index;
      const pickup_selected_index =
        this.props.final_search_form.selected_card_detail
          .pickup_selected_option_index;
      let bookingObject = {
        carrier: this.props?.final_search_form?.selected_card_json?.carrier?.id,
        charge_id: this.props?.final_search_form?.selected_card_json?.charge_id,
        charge_type_id:
          this.props?.final_search_form?.selected_card_json?.charge_type_id,
        container_type: this.props?.final_search_form.type?.includes("fcl")
          ? "FCL"
          : "LCL",
        vessel_service:
          this.props?.final_search_form?.selected_card_json?.vessel_Service.id,
        ETD_origin:
          this.props?.final_search_form?.selected_card_json?.etd_origin,
        rate: this.props?.final_search_form?.selected_card_detail?.bookNowPrice,
        origin_port: this.props?.queryParams?.from?.id,
        discharge_port:
          this.props?.final_search_form?.selected_card_json?.port_of_discharge
            ?.id,
        destination_port: this.props?.queryParams?.to?.id,
        agent_info: this.props?.AgentInformation?.id,
        shipper_info: isExistingPickupFactorySelected?.id,
        delivery_location: isExistingDeliveryFactorySelected?.id,
        isPickupChecked:
          this.props?.final_search_form?.selected_card_detail?.pickup_isChecked,
        isPortOriginChecked:
          this.props?.final_search_form?.selected_card_detail?.origin_isChecked,
        isFreightChecked:
          this.props?.final_search_form?.selected_card_detail
            ?.frieght_isChecked,
        isDischargeChecked:
          this.props?.final_search_form?.selected_card_detail
            ?.discharge_isChecked,
        isErsChecked:
          this.props?.final_search_form?.selected_card_detail?.ers_isChecked,
        isDeliveryChecked:
          this.props?.final_search_form?.selected_card_detail
            ?.delivery_isChecked,
        validity_from:
          this.props?.final_search_form?.selected_card_json?.valid_date_from,
        validity_to:
          this.props?.final_search_form?.selected_card_json?.valid_date_to,
        vendor_contract:
          this.props?.final_search_form?.selected_card_json?.vendor_contract
            ?.id,
        mode_of_transport:
          this.props?.final_search_form?.selected_card_json?.mode,
        spot_rate:  this.props?.final_search_form?.selected_card_json?.spotRate,
        schedule_id:
          this.props?.final_search_form?.selected_card_detail?.selectedSchedule
            ?.id,
        custom_broker: this.state?.selectedBroker?.id,
        consignee_role:this.props.transaction_type,
        agentProfileID: this.state?.AgentProfileInfo?.id,
        // Gated by usesInstantInsurance like insuranceFee: when insurance is switched
        // to RFQ the instant estimate must NOT be persisted, so a stale insuredValue
        // from a prior Calculate is dropped — keeping the either/or rule the other
        // insurance-persistence sites enforce (#8).
        insuredValue: this.usesInstantInsurance
          ? Number(
              (this.state.insuranceArr?.reduce((sum, item) => {
                  // console.log("---commodity_value---", item.commodity_value);
                  const value = Number(item.commodity_value);
                  return sum + (isNaN(value) ? 0 : value);
              }, 0) || 0).toFixed(2)
            )
          : 0,
        // bookedOnly: only premiums that become a booking INS charge line (created
        // policy) — matches the displayed Total Price + the INS charge lines (#4).
        // Zeroed when insurance is sent to RFQ — the instant premium isn't persisted (#11).
        insuranceFee: this.usesInstantInsurance
          ? Number(this.sumPremiums(this.state.insuranceArr, true).toFixed(2))
          : 0,
        // RFQ-quote booking linkage (#188): when this booking originates from a
        // presented RFQ quote (the Portal "Accept & create booking" handoff seeds
        // selected_card_json.rfqOffer), carry the source quote/RFQ ids so the
        // Booking links back to the agreed quote.
        quote_id: this.props?.final_search_form?.selected_card_json?.rfqOffer?.quoteId ?? null,
        rfq_id: this.props?.final_search_form?.selected_card_json?.rfqOffer?.rfqId ?? null,
      };

      if (this.props.final_search_form.type === "api-lcl") {
        bookingObject = {
          ...bookingObject,
          chargeable_weight: this.props?.final_search_form?.chargeableWeight,
          container_type: "LCL",
          freight_rate: Number(this.props?.final_search_form?.freightRate),
        };
      } else if (this.props.final_search_form.type === "api-fcl") {
        bookingObject = {
          ...bookingObject,
          _20stCounter: this.props?.final_search_form?.container?._20stCounter,
          _40hqCounter: this.props?.final_search_form?.container?._40hqCounter,
          _40stCounter: this.props?.final_search_form?.container?._40stCounter,
          _45hqCounter: this.props?.final_search_form?.container?._45hqCounter,
          _20stWeight:this.props?.final_search_form?.selected_card_json?._20stWeight,
          _40stWeight:this.props?.final_search_form?.selected_card_json?._40stWeight,
          _40hqWeight:this.props?.final_search_form?.selected_card_json?._40hqWeight,
          _45hqWeight:this.props?.final_search_form?.selected_card_json?._45hqWeight,
          isOverweight:this.props?.final_search_form?.selected_card_json?.isOverweight,
          _20stPrice:
            this.props.discount && this.props.discount.id
              ? this.props?.final_search_form?.selected_card_detail?._20stPrice
              : Number(
                  this.props?.final_search_form?.selected_card_json?.["20st"]
                ),
          _40hqPrice:
            this.props.discount && this.props.discount.id
              ? this.props?.final_search_form?.selected_card_detail?._40hqPrice
              : Number(
                  this.props?.final_search_form?.selected_card_json?.["40hq"]
                ),
          _40stPrice:
            this.props.discount && this.props.discount.id
              ? this.props?.final_search_form?.selected_card_detail?._40stPrice
              : Number(
                  this.props?.final_search_form?.selected_card_json?.["40st"]
                ),
          _45hqPrice:
            this.props.discount && this.props.discount.id
              ? this.props?.final_search_form?.selected_card_detail?._45hqPrice
              : Number(
                  this.props?.final_search_form?.selected_card_json?.["45hq"]
                ),
          container_type: "FCL",
        };
      }
      const pickup_charges =
        this.props?.final_search_form?.selected_card_json?.pickup_section?.[
          pickup_selected_index
        ] || {};
      const delivery_section =
        this.props?.final_search_form?.selected_card_json?.delivery_section?.[
          delivery_selected_index
        ] || {};

      let deliveryRateArr = [];
      if (
        delivery_section &&
        delivery_section.hasOwnProperty("rate") &&
        Array.isArray(delivery_section.rate)
      ) {
        deliveryRateArr =
          this.props?.final_search_form?.selected_card_detail?.delivery_charges;
      }

      let pickupRateArr = [];
      if (
        pickup_charges &&
        pickup_charges.hasOwnProperty("rate") &&
        Array.isArray(pickup_charges.rate)
      ) {
        pickupRateArr =
          this.props?.final_search_form?.selected_card_detail?.pickup_charges;
      }

      let booking_charges = {
        ers_section:
          this.props?.final_search_form?.selected_card_detail?.ers_charges,
        port_origin_section:
          this.props?.final_search_form?.selected_card_detail
            ?.port_fees_from_charges,
        port_discharge_section:
          this.props?.final_search_form?.selected_card_detail
            ?.port_fees_to_charges,
        pickup_section_charges: pickupRateArr,
        pickup_section: pickup_charges,
        delivery_section: delivery_section,
        delivery_section_charges: deliveryRateArr,
        discountID: this.props?.discount?.id,
        discountCode: this.props?.queryParams?.discount,
        po_number: selectedPoNumbers,
        style_nuumbers: styleNumbers,
        // Gated by usesInstantInsurance like insuredValue/insuranceFee/the INS charge
        // lines below: when insurance is switched to RFQ the instant estimate (its
        // commodities, premium_amount, any created policy_id) must NOT be persisted onto
        // the booking — only the INSURANCE RFQ is spawned (#11/#51 either/or).
        insurances: this.usesInstantInsurance ? this.state.insuranceArr : [],
        freight_section_charges: this.props?.final_search_form?.selected_card_json?.freightCharges,
      };

      // Skip the instant-premium INS charge lines when insurance is sent to RFQ —
      // the broker quotes price it, not the instant estimate (#11 either/or).
      if(this.usesInstantInsurance && this.state.insuranceArr && (this.state.insuranceArr).length > 0){
        booking_charges = getInsuranceChargeForCommodities(this.state.insuranceArr, booking_charges);
      }

      if(this.state.dutyTax_amount_subtotal && Object.keys(this.state.dutyTax_amount_subtotal).length > 0){
        const totalDutyTaxAmount = parseFloat(this.state.dutyTax_amount_subtotal.duties + this.state.dutyTax_amount_subtotal.taxes);
        if(totalDutyTaxAmount && totalDutyTaxAmount > 0){
            booking_charges = calculateDutyTaxFee(totalDutyTaxAmount, booking_charges);
        }
      }

      // Persist a BROK line when the chosen broker carries a fee, mirroring the
      // duty/insurance charge builders so the booked charges match the displayed
      // Total Price (#1).
      if(this.state.brokerageFee && this.state.brokerageFee > 0){
        booking_charges = calculateBrokerageFee(this.state.brokerageFee, booking_charges);
      }
      // const result = await this.props.Create_New_Booking(
      //   bookingObject,
      //   booking_charges
      // );
      // Project the gathered data into the shape the coded create-booking BB function
      // expects: { booking: {resolved relation ids + scalars}, bookingInsurance[] }.
      // (quoteId is injected by the thunk AFTER it runs saveQuote first — create-booking
      // does the booking half only and links to the Quote that saveQuote creates.)
      // undefined fields are dropped by JSON.stringify and the function's own clean().
      const bookingPayload = {
        booking: {
          webBooking: true,
          containerType: bookingObject.container_type,
          modeTransport: bookingObject.mode_of_transport,
          consigneeRole: bookingObject.consignee_role,
          etdOrigin: bookingObject.ETD_origin,
          isOverweight: bookingObject.isOverweight,
          styleNumbers: styleNumbers || undefined,
          insuredValue: bookingObject.insuredValue,
          insuranceFee: bookingObject.insuranceFee,
          // The logged-in customer entity owns the booking. USER_DETAILS IS the customer/
          // company record, so its .id is the entity id — webuser.entity/entity are null for
          // these logins, so .id MUST come first (dropping it made customerId undefined →
          // JSON.stringify omits it). Same source handleSaveQuote uses for Quote.customer.
          customerId: this.props.user?.id,
          shipperId: bookingObject.shipper_info,
          carrierId: bookingObject.carrier,
          vendorContractId: bookingObject.vendor_contract,
          portOriginId: bookingObject.origin_port,
          portDischargeId: bookingObject.discharge_port,
          portDestinationId: bookingObject.destination_port,
          vesselServiceId: bookingObject.vessel_service,
          scheduleId: bookingObject.schedule_id,
          deliveryLocationId: bookingObject.delivery_location,
          // FLAG(neil-verify): createdByUser = the logged-in web user record id.
          createdByUserId: this.props.user?.webuser?.userid,
          poIds: selectedPoNumbers,
          agentInfo: this.props?.AgentInformation?.id,
          agentProfileID: this.state?.AgentProfileInfo?.id,
          brokerId: this.state?.selectedBroker?.id,
        },
        // Booking-linked insurance rows (created instant policies), gated like the
        // booking's insuredValue/insuranceFee — not persisted when insurance → RFQ (#11/#51).
        bookingInsurance: this.usesInstantInsurance
          ? (this.state.insuranceArr || [])
              .filter((i) => Number(i.commodity_value) > 0)
              .map((i) => ({
                commodityCategory: i.category ?? null,
                commodityDescription: i.commodity_description ?? null,
                commodityValue: Number(i.commodity_value) || null,
                premium: Number(i.quote?.premium_amount) || null,
                profitPercent: null,
                policyReference: i.policy_id ?? null,
              }))
          : [],
      };
      // saveQuote-first: persist the Quote (everything on this screen) to get a quoteId,
      // then create-booking with { booking, quoteId, bookingInsurance }.
      const result = await this.props.Create_Quote_And_Booking(
        buildSaveQuotePayload(this.buildSaveQuoteInput()),
        bookingPayload
      );
      if (result[0]) {
        // RFQ-quote association (#188): create + link the REAL Booking to the source
        // quote in the orchestrator (Booking.quote → fills Quote.bookings; Quote
        // accepted + RFQ → ACCEPTED). This is the booking the RFQ data zone owns, so
        // prefer its ref for the confirmation. Best-effort — a link failure must not
        // surface as a booking error.
        let bookingId = result[1];
        // #188: result[3] = the Booking RECORD id — the value BB links/relates on
        // (result[1] is the human-facing number, display only).
        const bookingRecordId = result[3] ?? null;
        if (rfqOffer && rfqOffer.quoteId != null) {
          try {
            const linked = await acceptQuote(rfqOffer.quoteId, bookingRecordId);
            // #P2-2: keep the REAL Create_New_Booking number (result[1]); only override it
            // with the authoritative ref (bookingRefOf → primeFreightRef), never the
            // fabricated `BKG-…` bookingId that would replace a real number with a synthetic.
            const linkedRef = bookingRefOf(linked);
            if (linkedRef) bookingId = linkedRef;
          } catch (e) { /* booking created; association best-effort */ }
        }
        // #191 (A half): the spawned RFQ should reference the Booking RECORD id, not
        // the display number (D's createRFQ rel lands in a follow-up; A is now correct).
        const rfq = await this.maybeCreateBookingRfq(bookingRecordId ?? bookingId);
        this.props.final_booking_button({
          bookingSuccessful: true,
          bookingId,
          ...(rfq ? { rfq } : {}),
        });
      } else {
        this.props.updateErrorAndLoading(
          "Error ! Please Contact Prime Freight",
          undefined
        );
      }
    } else {
      this.setState({ ShowPopUp: true });
      const form = {
        MessageType: "Error",
        MessageDescription: "Select Shipper first",
      };
      this.setState({ form: form });
    }
  };

  openPopUpFactory = () => {
    this.setState({ ShowPopUpShipperForm: true });
  };

  openPopUpFactoryDelivery = () => {
    this.setState({ ShowPopUpDeliveryForm: true });
  };

  closePopUp = () => {
    this.setState({ ShowPopUp: false });
  };

  handleGoBack = () => {
    this.props.final_submit_button(false);
    this.props.back_submit_button(true);
  };

  handleCreate = (inputValue) => {
    this.setState({ isLoading: true });
    setTimeout(() => {
      const newOption = createOption(inputValue);
      this.setState((prevState) => ({
        poNumbers: [...prevState.poNumbers, newOption],
        isLoading: false,
      }));

      let payload = {
        orderNumbers: newOption.value,
        orderPurchaser: {
          id: this.props.user.id,
        },
      };

      try {
        addPurchaseOrder(this.props.jwt_token, payload).then((result) => {
          if (result[0]) {
            newOption.id = result[1];
            this.setState((prevState) => ({
              selectedPos: [...prevState.selectedPos, newOption],
            }));
          }
        });
      } catch (error) {
        console.error("Error occurred while adding po :", error);
      }
    }, 1000);
  };

  async fetchOptions(inputValue) {
    if (!inputValue) return;

    const newOptions = await searchPOs(
      this.props.jwt_token,
      inputValue,
      this.props.user.id
    );
    const formattedOptions = newOptions.map((option) =>
      createOption(option.orderNumbers, option.id, option.styleNo)
    );

    this.setState({
      poNumbers: formattedOptions,
    });
  }

  handlePoInput = (inputValue) => {
    this.fetchOptions(inputValue);
  };

  render() {
    const { poNumbers, isLoading, selectedPos, customBroker,loadingBrokers, AgentProfileInfo } = this.state;
    const {
      final_search_form,
      isExistingPickupFactorySelected,
      isExistingDeliveryFactorySelected,
      AgentInformation,
      transaction_type,
      queryParams,
      commodityList
    } = this.props;

    const schedule = final_search_form?.selected_card_detail?.selectedSchedule;
    return (
      <>
        <div className="final-view-container">
          <div className="no-result testR1">
            <Card style={{ height: "100%" }} className="no-result-card testR1">
              <div>
                <button className="back-btn" onClick={this.handleGoBack}>
                  Back
                </button>
              </div>
              <div className="view_header" style={{borderBottom: '0px'}}>Review Details</div>
              <Card title="Booking Details" //bordered={false}
               style={{ width: "auto" }} className='no-padding'>
              <div className="parent_grid">
                <div className="child_grid">
                  <div className="details_grid_not_mutable">
                    <div className="details_grid_not_mutable_div">
                      <div className="details_grid_not_mutable_div_heading">
                        Carrier:
                      </div>
                      <div className="details_grid_not_mutable_div_state">
                        {final_search_form.selected_card_json.sealine}
                      </div>
                    </div>
                    <div className="details_grid_not_mutable_div">
                      <div className="details_grid_not_mutable_div_heading">
                        Container Type:
                      </div>
                      <div className="details_grid_not_mutable_div_state">
                        {final_search_form.type.includes("fcl") ? "FCL" : "LCL"}
                      </div>
                    </div>
                    {final_search_form.container !== undefined && (
                      <div className="details_grid_not_mutable_div">
                        <div className="details_grid_not_mutable_div_heading">
                          Container Size:
                        </div>
                       <div className="details_grid_not_mutable_div_state">
                        {final_search_form.container._20stCounter > 0 && (
                          final_search_form.selected_card_json.isOverweight
                            ? `20 STD-${final_search_form.container._20stCounter} (${final_search_form.selected_card_json._20stWeight} KG) `
                            : `20 STD-${final_search_form.container._20stCounter}`
                        )}

                        {final_search_form.container._40stCounter > 0 && (
                          final_search_form.selected_card_json.isOverweight
                            ? `40 STD-${final_search_form.container._40stCounter} (${final_search_form.selected_card_json._40stWeight} KG) `
                            : `40 STD-${final_search_form.container._40stCounter}`
                        )}

                        {final_search_form.container._40hqCounter > 0 && (
                          final_search_form.selected_card_json.isOverweight
                            ? `40 HQ-${final_search_form.container._40hqCounter} (${final_search_form.selected_card_json._40hqWeight} KG) `
                            : `40 HQ-${final_search_form.container._40hqCounter}`
                        )}

                        {final_search_form.container._45hqCounter > 0 && (
                          final_search_form.selected_card_json.isOverweight
                            ? `45 HQ-${final_search_form.container._45hqCounter} (${final_search_form.selected_card_json._45hqWeight} KG)`
                            : `45 HQ-${final_search_form.container._45hqCounter}`
                        )}
                      </div>
                      </div>
                    )}

                    {final_search_form.total_shipment !== undefined && (
                      <div className="details_grid_not_mutable_div">
                        <div className="details_grid_not_mutable_div_heading">
                          Total CBM And Weight:
                        </div>
                        <div className="details_grid_not_mutable_div_state">
                          {final_search_form.total_shipment.totalVolume} CBM ,{" "}
                          {final_search_form.total_shipment.totalWeight}{" "}
                          {final_search_form.total_shipment.weightUnit}
                        </div>
                      </div>
                    )}

                    <div className="details_grid_not_mutable_div">
                      <div className="details_grid_not_mutable_div_heading">
                        Vessel Service:
                      </div>
                      <div className="details_grid_not_mutable_div_state">
                        {(final_search_form.selected_card_json.vessel_Service &&
                          final_search_form.selected_card_json.vessel_Service.name) ||
                          "Prime Freight Service"}

                        {/*{final_search_form.selected_card_json.vesselService!==undefined?({final_search_form.selected_card_json.vessel_Service.name}):"Prime Freight Service"}*/}
                      </div>
                    </div>
                    <div className="details_grid_not_mutable_div">
                      <div className="details_grid_not_mutable_div_heading">
                        ETD Origin:
                      </div>
                      <div className="details_grid_not_mutable_div_state">
                        {final_search_form.selected_card_json.etd_origin}
                      </div>
                    </div>
                    <div className="details_grid_not_mutable_div">
                      <div className="details_grid_not_mutable_div_heading">
                        Origin Port:
                      </div>
                      <div className="details_grid_not_mutable_div_state">
                        {final_search_form.selected_card_json.port_of_origin}
                      </div>
                    </div>
                    <div className="details_grid_not_mutable_div">
                      <div className="details_grid_not_mutable_div_heading">
                        Discharge Port:
                      </div>
                      <div className="details_grid_not_mutable_div_state">
                        {final_search_form.selected_card_json.port_of_discharge &&
                          final_search_form.selected_card_json.port_of_discharge
                            .company_name}
                      </div>
                    </div>
                    <div className="details_grid_not_mutable_div">
                      <div className="details_grid_not_mutable_div_heading">
                        Destination Port:
                      </div>
                      <div className="details_grid_not_mutable_div_state">
                        {final_search_form.selected_card_json.ers_location}
                      </div>
                    </div>
                    <div className="details_grid_not_mutable_div">
                      <div className="details_grid_not_mutable_div_heading">
                          Consignee Role:
                      </div>
                      <div className="details_grid_not_mutable_div_state">
                          {transaction_type}
                      </div>
                    </div>
                   
                    <div
                      className="details_grid_not_mutable_div"
                      style={{ border: "none" }}
                    >
                      <div className="details_grid_not_mutable_div_heading">
                        Agent Information:
                      </div>
                      <div className="details_grid_not_mutable_div_state">
                        { (AgentProfileInfo && AgentProfileInfo?.company_name)  ? AgentProfileInfo?.company_name : (AgentInformation && AgentInformation.name)}
                      </div>
                    </div>
                    
                  </div>
                </div>
                <div className="child_grid">
                  <div className="details_grid_mutable">
                    <div className="details_grid_mutable_div">
                      <div className="input-heading-width">PO Number</div>
                      <div
                        className="input-container-width"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {/* <div style={{display: "flex", alignItems:"center",justifyContent:"center"}}> */}
                        <CreatableSelect
                          isClearable
                          isSearchable
                          isMulti
                          isDisabled={isLoading}
                          isLoading={isLoading}
                          onChange={(newValue) => {
                            const next = newValue || [];
                            const prev = this.state.selectedPos || [];
                            const added = next.filter((nv) => !prev.some((p) => p.value === nv.value));
                            this.setState({ selectedPos: [...next] });
                            // Pull newly-selected POs' commodities into Customs + Insurance (#179).
                            if (added.length) this.importPoCommodities(added);
                          }}
                          onCreateOption={this.handleCreate}
                          options={poNumbers}
                          value={selectedPos}
                          onInputChange={this.handlePoInput}
                          createOptionPosition="first"
                          className="factory-input-width"
                          formatCreateLabel={(inputValue) => (
                            <div style={{ fontWeight: "bolder" }}>
                              Add new PO "{inputValue}"
                            </div>
                          )}
                        />
                        {/* </div> */}
                      </div>
                    </div>

                    <div className="details_grid_mutable_div">
                      <div
                        className="input-heading-width" //style={{width:"30%"}}
                      >
                        <span style={{ display: "inline-block",
                            marginRight: "2px",
                            color: "#f5222d",
                            fontSize: "14px",
                            fontFamily: "SimSun, sans-serif",
                            lineHeight: 1, }}>*</span>
                        {transaction_type === 'Importer' ? (
                         "Shipper Information"
                        ) : (
                            "Pickup Location"
                        )}
                      </div>
                      <div
                        className="input-container-width" //style={{width:"70%"}}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <PickupDeliveryFactory
                            onFactoryDataChange={() =>
                              this.onFactoryDataChange()
                            }
                            isPickupFactory={true}
                            mode={"pickup"}
                            changeDrop={this.state.changeDropDown}
                            NewFactoryMode={() =>
                              this.ChaneNewPickFactoryToTrue()
                            }
                          />

                          {this.state.pickUpChange &&
                          Object.keys(isExistingPickupFactorySelected).length >
                            0 ? (
                            <div className="" style={{ textAlign: "center" }}>
                              <Tooltip placement="top" title="Edit Shipper">
                                <span onClick={() => this.openPopUpFactory()}>
                                  <Icon
                                    type="edit"
                                    theme="twoTone"
                                    style={{
                                      fontSize: "20px",
                                      marginLeft: 0,
                                      paddingLeft: "5px",
                                      alignSelf: "center",
                                      cursor: "pointer",
                                    }}
                                  />
                                </span>
                              </Tooltip>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                    {(this.state.newPickup ||
                      this.state.ShowPopUpShipperForm) && (
                      <PopUpForFactory
                        queryParams={queryParams}
                        selectedFactoryJson={isExistingPickupFactorySelected}
                        isPickupMode={true}
                        handleSaveDetails={() => this.handleSaveDetails()}
                        newFactory={this.state.newPickup}
                      />
                    )}
                    {this.state.ShowPopUp ? (
                      <div className="error-msg">
                      {transaction_type === 'Importer' ? 
                        "Please select shipper first!" :
                        "Please select pickup location first!"}
                      </div>
                    ) : (
                      ""
                    )}

                    <div className="details_grid_mutable_div">
                      <div
                        className="input-heading-width" //style={{width:"30%"}}
                      >
                        {
                          transaction_type === 'Importer' ? "Delivery Location" : "Receiver Information"
                        }
                      </div>
                      <div
                        className="input-container-width" //style={{width:"70%"}}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <PickupDeliveryFactory
                            onFactoryDataChange={() =>
                              this.onFactoryDeliveryChange()
                            }
                            isPickupFactory={false}
                            mode={"pickup"}
                            changeDrop={this.state.changeDropDown}
                            NewFactoryMode={() =>
                              this.ChaneNewDeliveryFactoryToTrue()
                            }
                          />
                          {this.state.deliveryChange &&
                          Object.keys(isExistingDeliveryFactorySelected)
                            .length > 0 ? (
                            <div style={{ textAlign: "center" }}>
                              <Tooltip
                                placement="top"
                                title="Edit Delivery Location"
                                autoAdjustOverflow
                              >
                                <span
                                  onClick={() =>
                                    this.openPopUpFactoryDelivery()
                                  }
                                >
                                  <Icon
                                    type="edit"
                                    theme="twoTone"
                                    style={{
                                      fontSize: "20px",
                                      marginLeft: 0,
                                      paddingLeft: "5px",
                                      alignSelf: "center",
                                      cursor: "pointer",
                                    }}
                                  />
                                </span>
                              </Tooltip>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      {(this.state.newDelivery ||
                        this.state.ShowPopUpDeliveryForm) && (
                        <PopUpForFactory
                          queryParams={queryParams}
                          selectedFactoryJson={
                            isExistingDeliveryFactorySelected
                          }
                          isPickupMode={false}
                          handleSaveDetails={() => this.handleSaveDetails()}
                          newFactory={this.state.newDelivery}
                        />
                      )}
                    </div>
                    <div className="details_grid_mutable_div">
                      <div className="input-heading-width" //style={{width:"30%"}}
                      >
                          Custom Broker
                      </div>
                      <div className="input-container-width" //style={{width:"70%"}}
                      >
                          <div style={{display: "flex", alignItems:"center",justifyContent:"center"}}>
                          <Select
                              placeholder="Select a broker"
                              loading={loadingBrokers}
                              //value={this.state.selectedBroker}
                              value={this.state.selectedBroker ? this.state.selectedBroker.companyName : undefined}
                              className='factory-input-width'
                              onChange={this.handleCustomBrokerChnage}
                          >
                              {customBroker.map(broker => (
                              <Option key={broker.id} value={broker.companyName}>
                                  {broker.companyName}
                              </Option>
                              ))}
                          </Select>
                          </div>
                      </div>
                      </div>
                      {schedule && !schedule?.id && (
                        // Show the spinner until schedule.id is available
                        <div style={{ display: 'flex', justifyContent: 'center', padding: '10px', minHeight:'50px' }}>
                          <Spin style={{
                                  margin: 'auto'
                              }}
                              indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />}
                          />
                        </div>
                      )}
                      {schedule && schedule?.id && (
                        <div
                          style={{
                            //borderBottom: "1px solid #D2D2D2",
                            paddingBottom: "1rem",
                            color: "black"
                          }}
                        >
                          <Row style={{ padding: "1rem 0px 1rem 0" }}>
                            <Col xs={24} sm={12} style={{ paddingBottom: "1rem" }}>
                              <span>Schedule Voyage: {schedule?.voyage?.endsWith("-TBA") ? "TBA" : (schedule?.voyage)}</span>
                            </Col>
                            <Col xs={24} sm={12}  style={{ paddingBottom: "0" }}>
                              <div style={{ float: "left" }}>
                                <span
                                  //style={{ fontWeight: "600", fontSize: "12px" }}
                                >
                                  {
                                    (schedule?.transit_time) ? `Transit Time: ${schedule.transit_time} days`
                                    : ( ( schedule?.portTransitTime || schedule?.port_to_port_transit_time) && `Port Transit Time : ${schedule?.portTransitTime || schedule?.port_to_port_transit_time} days`)
                                  }
                                </span>
                              </div>
                            </Col>
                          </Row>
                          <div className="schedule-info-width">
                            <div style={{ paddingBottom: "3rem" }}>
                              <div>
                                Mother Vessel: {((schedule?.vesselName || schedule?.mother_vessel_name)?.endsWith("-TBA") ? "TBA" : schedule?.vesselName || schedule?.mother_vessel_name)}
                              </div>
                            </div>
                            <ScheduleTimeline schedule={schedule} />
                          </div>
                        </div>
                      )}
                      <div className="details_grid_not_mutable_div" style={{color:"black"}}>
                        <div className="details_grid_not_mutable_div_heading">
                            Total Shipping Cost:
                        </div>
                        <div className="details_grid_not_mutable_div_state">
                            {final_search_form.selected_card_detail.bookNowPrice}
                        </div>
                      </div>
                  
                 
                  </div>
                </div>
              </div>
              </Card>
              {/* Instant-premium estimate card — hidden when insurance is sent to RFQ so
                  the instant premium and the broker RFQ aren't both persisted (#11). */}
              {this.usesInstantInsurance && (
              <Card title="Estimate Cargo Insurance"
                  style={{ width: 'auto', margin:'1rem 0' }} className='no-padding'>
                { (commodityList && commodityList.length >0) ?
                <div className="parent_grid">
                <div className="child_grid">
                    <div className="details_grid_not_mutable">
                          <CargoInsurance
                            //{...{ form: this.props.form }}
                            // Remount on PO import so the child's internal premium
                            // state can't keep a pre-import estimate (#2).
                            key={`cargo-insurance-${this.state.importEpoch}`}
                            form={this.props.form}
                            commodityArr = {this.state.commodityArr}
                            queryParams={this.props.queryParams}
                            final_search_form = {this.props.final_search_form}
                            jwt_token={this.props.jwt_token}
                            onInsuranceAmountChange={this.handleInsuranceAmountChange}
                            onCommodityChange={this.handleCommodityChange}
                            onAddCommodity={this.handleAddCommodity}
                            onDeleteCommodity={this.handleDeleteCommodity}
                        />
                    </div>
                </div>
                
                <div className="child_grid">
                    <div className="details_grid_not_mutable">
                    {this.state.insuranceArr && this.state.insuranceArr.length>0 &&
                            <div className="insurance_details">
                                {this.state?.insuranceArr?.map(item => {
                                    const description = item?.commodity_description;
                                    // Same NaN guard as sumPremiums: a 'quote requested' commodity has no
                                    // premium_amount (undefined), so guarding only against null rendered
                                    // the literal "$ undefined" — show "-" instead, with .toFixed (#10).
                                    const p = Number(item?.quote?.premium_amount);
                                    const premiumAmount = Number.isFinite(p) ? p.toFixed(2) : '-';
                                    //console.log("premium Amount: ",premiumAmount)
                                    //const policy = item?.policy_id

                                    return (
                                        <>
                                        <div className="details_grid_not_mutable_div">
                                                <div className="details_grid_not_mutable_div_heading">
                                                {description}
                                                </div>
                                                <div className="details_grid_not_mutable_div_state">
                                                    {`$ ${premiumAmount}`}
                                                </div>
                                        </div>
                                        </>
                                    );
                                })}
                            </div>
                        }

                        <div className="details_grid_not_mutable_div">
                                <div className="details_grid_not_mutable_div_heading">
                                Estimated total premium:
                                </div>
                                <div className="details_grid_not_mutable_div_state">
                                    {/* Card shows the CALCULATED premium (bookedOnly=false) so the
                                        customer sees the figure right after Calculate (#1). The booking
                                        Total Price still adds insurance only once a policy is created
                                        (calculateTotalPrice uses sumPremiums(..., true)), so the charge
                                        can't exceed what's actually booked (#8/#20). */}
                                    {`$ ${this.sumPremiums(this.state?.insuranceArr, false).toFixed(2)}`}
                                </div>
                        </div>
                        </div>
                    </div>
                </div>
                :
                <LoadingIndicator />
                }
              </Card>
              )}
              <Card title="Estimate Duty and Taxes" //bordered={false}
                    style={{ width: 'auto', margin:'1rem 0' }} className='no-padding'>
                  <div style={{padding:"1rem"}}>
                      <div>
                          <DutyAndTax
                              {...{ form: this.props.form }}
                              dutyTax={this.state.dutyTax}
                              onDutyTaxChange={this.handleDutyTaxChange}
                              onAddDutyTax={this.handleAddDutyTax}
                              onDeleteDutyTax={this.handleDeleteDutyTax}
                              queryParams={this.props.queryParams}
                              final_search_form = {this.props.final_search_form}
                              jwt_token={this.props.jwt_token}
                              onDutyTaxAmountSubtotalChange={this.handleDutyTaxAmountSubtotalChange}
                          />
                      </div>
                      <div style={{paddingTop:"1rem"}}>
                          <div className="details_grid_not_mutable_div">
                                  <div className="details_grid_not_mutable_div_heading">
                                  Duties:
                                  </div>
                                  <div className="details_grid_not_mutable_div_state">
                                      {money(this.state.dutyTax_amount_subtotal.duties)}
                                  </div>
                          </div>
                          <div className="details_grid_not_mutable_div">
                                  <div className="details_grid_not_mutable_div_heading">
                                  Taxes:
                                  </div>
                                  <div className="details_grid_not_mutable_div_state">
                                      {money(this.state.dutyTax_amount_subtotal.taxes)}
                                  </div>
                          </div>
                          <div className="details_grid_not_mutable_div">
                                  <div className="details_grid_not_mutable_div_heading">
                                  <b> Total Price: </b>
                                  </div>
                                  <div className="details_grid_not_mutable_div_state">
                                      {money(this.calculateTotalPrice())}

                                  </div>
                          </div>
                      </div>
                  </div>
              </Card>
              <BookingRfqSections
                insuranceMode={this.state.rfqInsuranceMode}
                insuranceArr={this.state.insuranceArr}
                customsRfq={this.state.rfqCustoms}
                warehouseRfq={this.state.rfqWarehouse}
                warehouseServices={this.state.rfqWarehouseDetail}
                onInsuranceMode={(v) => this.setState({ rfqInsuranceMode: v })}
                onCustomsRfq={(v) => this.setState({ rfqCustoms: v })}
                onWarehouseRfq={(v) => this.setState({ rfqWarehouse: v })}
                onWarehouseServices={(v) => this.setState({ rfqWarehouseDetail: v })}
              />
              <div style={{ margin: '16px' }}>
                <Checkbox
                  checked={this.state.termsAccepted}
                  onChange={this.handleTermsAcceptance}
                >
                  I agree to the <a href="https://www.primefreight.com/booking-terms-and-conditions/" target="_blank" rel="noopener noreferrer">Terms and Conditions</a>
                </Checkbox>
              </div>
              <div className="center-button">
                <button
                  className="create-booking-btn"
                  style={{ marginRight: 8, background: '#fff', color: '#1890ff', border: '1px solid #1890ff' }}
                  disabled={this.state.savingQuote}
                  onClick={() => this.handleSaveQuote()}
                >
                  {this.state.savingQuote ? 'Saving…' : 'Save quote'}
                </button>
                <button
                  className="create-booking-btn"
                  disabled={!this.state.termsAccepted}
                  onClick={() => this.handleCreateBooking()}
                >
                  Create Booking
                </button>
              </div>
              {this.props.saveDataShowOverlay && (
                <TransparentOverlay message="Please wait..." />
              )}
            </Card>
          </div>
        </div>
      </>
    );
  }
}
const WrappedFinalView = Form.create({ name: 'booking-review' })(StartCard);
const mapStateToProps = (state) => {
  return {
    final_search_form: state.route.final_search_form,
    isExistingPickupFactorySelected:
      state.form.pickup.selectedExistingFactoryJson,
    isExistingDeliveryFactorySelected:
      state.form.delivery.selectedExistingFactoryJson,
    AgentInformation: state.form.AgentInformation,
    queryParams: state.route.queryParams,
    discount: state.route.discount,
    jwt_token: state.route.CLIENT_TOKEN?.JWT_TOKEN,
    user: state.route.USER_DETAILS,
    saveDataShowOverlay: state.code_config.saveDataShowOverlay,
    transaction_type: state.code_config.transactionType,
    commodityList: state.route.commodityList,
    initAuth: state.code_config.initAuth,
  };
};

// final_search_form
// export default connect(mapStateToProps, actions)(StartCard);
export default withRouter(connect(mapStateToProps, actions)(WrappedFinalView));

// import React, {Component} from 'react';
// import './FinalView.css';
//
// class FinalView extends Component {
//     constructor(props) {
//         super(props);
//
//         this.state = {
//             carrier: 'Carrier Name', rate: 'Rate', vesselService: 'Vessel Service', etdOrigin: new Date(),
//         };
//     }
//
//     render() {
//         const {carrier, rate, vesselService, etdOrigin} = this.state;
//
//         return (<>
//                 <div className="setting_up_height_for_final_view">
//                     <div className="final-view-container">
//                         <div className="grid_view_for_selection">
//                             <div className="center-div">
//                                 <h1>Review Selected Details:</h1>
//                             </div>
//                             <div className="details-container">
//                                 <p><strong>Carrier:</strong> {carrier}</p>
//                                 <p><strong>Rate:</strong> {rate}</p>
//                                 <p><strong>Vessel Service:</strong> {vesselService}</p>
//                                 <p><strong>ETD Origin:</strong> {etdOrigin.toLocaleDateString()}</p>
//                                 {/* Add more properties as needed */}
//                             </div>
//                             <div className="price-container">
//                                 <h2>Total Price:</h2>
//                                 {/* Calculate and display total price based on rate */}
//                                 {/* Example: */}
//                                 <p className="total-price">Total Price: $500</p>
//                             </div>
//                             <div className="button-container">
//                                 <button className="create-booking-btn" onClick={this.handleCreateBooking}>
//                                     Create Booking
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </>
//
//         );
//     }
//
//     handleCreateBooking = () => {
//         // Logic for creating the booking
//     };
// }
//
// export default FinalView;
